const scriptURL = document.querySelector('script[src*="build.js"]').src;
__webpack_public_path__ = scriptURL.slice(0, scriptURL.lastIndexOf('/') + 1);

document.documentElement.style.setProperty('--scrollbar-width', (window.innerWidth - document.documentElement.clientWidth) + "px");
import $ from "jquery";
import './polyfils/forEach';
import {accordeon} from './components/accordeon';
import Vue from 'vue';
import store from "../vue/store";
import i18n from '../vue/plugins/i18n';
// import './components/sap';
// import './components/svg';
import Presentation from '../vue/Presentation.vue';
import Header from '../vue/Header.vue';
import Menu from '../vue/Menu.vue';
//import Projects from '../vue/Projects.vue';
import Employee from "../vue/Employee.vue";
import Map from '../vue/Map.vue';
import Bag from '../vue/Bag.vue';
import List from '../vue/List.vue';

import 'intersection-observer';
import {setI18n} from "./components/htmlTranslation";
import assertUrl from "../js/components/assetUrl";
import "../js/components/financeTable";
import "../js/components/team";
import "../js/components/strategy";
import "../js/components/router";
import VueMq from 'vue-mq';
import GLightbox from 'glightbox';
import Swiper from "swiper";

import normalSlider from "./components/normal-slider";

setI18n(i18n);

normalSlider();

const assetUrlPlugin = {
    install(Vue, options) {
        Vue.prototype.assetUrl = assertUrl;
    },
};
Vue.use(assetUrlPlugin);

Vue.use(VueMq, {
    breakpoints: {
        mobile: 769,
        tablet: 993,
        desktop: Infinity,
    },
})

new Vue({
    el: '#header__app',
    store,
    i18n,
    render: h => h(Header),
});

new Vue({
    el: '#bag__app',
    store,
    i18n,
    render: h => h(Bag),
});

document.querySelectorAll('.project__list-app').forEach((projectList) => {
    const projectKey = projectList.getAttribute('data-project-name');
    const listItems = projectList.getAttribute('data-list-items');
    let items = [];

    if(projectKey) {
        i18n.t(`companyProjects.${projectKey}.list.items`).forEach((item, itemKey) => {
            items.push({id: itemKey});
        });
        new Vue({
            el: projectList,
            store,
            i18n,
            render: h => h(List,
                {
                    props: {
                        listTranslationsKey: `companyProjects.${projectKey}.list.items`,
                        items: items,
                    },
                }
            ),
        });
    }

    if(listItems) {
        i18n.t(`${listItems}`).forEach((item, itemKey) => {
            items.push({id: itemKey});
        });
        new Vue({
            el: projectList,
            store,
            i18n,
            render: h => h(List,
                {
                    props: {
                        listTranslationsKey: `${listItems}`,
                        items: items,
                    },
                }
            ),
        });
    }

});

new Vue({
    el: '#presentation__app',
    store,
    i18n,
    render: h => h(Presentation,
        {
            props: {
                presentationId: 'gorkov',
            },
        }
    ),
});

new Vue({
    el: '#presentation-komleva__app',
    store,
    i18n,
    render: h => h(Presentation,
        {
            props: {
                presentationId: 'komleva',
            },
        }
    ),
});

new Vue({
    el: '#presentation-baranov__app',
    store,
    i18n,
    render: h => h(Presentation,
        {
            props: {
                presentationId: 'baranov',
            },
        }
    ),
});

new Vue({
    el: '#presentation-matushin__app',
    store,
    i18n,
    render: h => h(Presentation,
        {
            props: {
                presentationId: 'matushin',
            },
        }
    ),
});

new Vue({
    el: '#presentation-nartov__app',
    store,
    i18n,
    render: h => h(Presentation,
        {
            props: {
                presentationId: 'nartov',
            },
        }
    ),
});

new Vue({
    el: '#presentation-antipov__app',
    store,
    i18n,
    render: h => h(Presentation,
        {
            props: {
                presentationId: 'antipov',
            },
        }
    ),
});


new Vue({
    el: '#presentation-zaharov__app',
    store,
    i18n,
    render: h => h(Presentation,
        {
            props: {
                presentationId: 'zaharov',
            },
        }
    ),
});

new Vue({
    el: '#presentation-zvirko__app',
    store,
    i18n,
    render: h => h(Presentation,
        {
            props: {
                presentationId: 'zvirko',
            },
        }
    ),
});

new Vue({
    el: '#menu__app',
    store,
    i18n,
    render: h => h(Menu),
});

/*new Vue({
    el: '#projects__app',
    store,
    i18n,
    render: h => h(Projects),
});*/

new Vue({
    el: '#employee__app',
    store,
    i18n,
    render: h => h(Employee),
});

new Vue({
    el: '#map__app',
    store,
    i18n,
    render: h => h(Map),
});

accordeon($('.accordeon-js'));

$('.scroll-link').click(function (e) {
    e.preventDefault();
    store.dispatch('scrollToElement', {
        element: document.getElementById($(this).attr('href')),
        duration: 600
    });
})

const lightbox = GLightbox({
    closeEffect: 'none',
});

document.addEventListener('click', function (e) {
    const target = e.target;
    let hrefTarget = target.closest(".videobox");

    if (target.classList.contains('videobox')) {
        hrefTarget = target;
    } else if (target.classList.contains('videobox-nostyle')) {
        hrefTarget = target;
    }

    if (hrefTarget) {
        console.log('Found target GLightbox')
        e.preventDefault();
        lightbox.setElements([{'href': hrefTarget.getAttribute('href')}]);
        lightbox.open();
    }
});

(function() {
    const breakpoint = window.matchMedia( '(min-width:768px)' );
    let mySwiper;

    const breakpointChecker = function() {
        if ( breakpoint.matches === true ) {
            if ( mySwiper !== undefined ) {
                $(".swiper-container.myCustomSwiper").each(function(){
                    this.swiper.destroy(true, true);
                });
            }
            return;
        } else if ( breakpoint.matches === false ) {
            return enableSwiper();
        }
    };

    const enableSwiper = function() {
        mySwiper = new Swiper(".myCustomSwiper", {
            slidesPerView: "auto",
            spaceBetween: 15,
            navigation: {
                nextEl: ".myCustomSwiper__next",
                prevEl: ".myCustomSwiper__prev",
            },
        });
    };

    breakpoint.addListener(breakpointChecker);
    breakpointChecker();
})();